"use client"

import { useSession } from "next-auth/react"
import { useEffect, useRef } from "react"
import { useMauticTracking } from "@/hooks/useMauticTracking"
import type { MauticCampaignEvent, PageViewParams } from "@/lib/mautic-campaign-tags"

interface MauticPageTrackerProps extends MauticCampaignEvent {}

export function MauticPageTracker({ mt_event, page_title, pageurl, tags }: MauticPageTrackerProps) {
   const { data: session } = useSession()
   const { trackPageView } = useMauticTracking()

   const firedFor = useRef<string | null>(null)

   useEffect(() => {
      const email = session?.user?.email ?? ""
      const fireKey = `${mt_event}|${pageurl}|${email}`
      if (firedFor.current === fireKey) return

      const params: PageViewParams = {
         mt_event,
         page_title,
         tags,
         page_url: pageurl,
      }
      if (email) params.email = email
      trackPageView(params)
      firedFor.current = fireKey
   }, [mt_event, page_title, pageurl, tags, session?.user?.email, trackPageView])

   return null
}
